import * as Sentry from '@sentry/nextjs';
import * as config from '../config';

global.sentry = Sentry;

export default (error, additionalInfo) => {
  if (config.ENV !== 'production') {
    console.error(error);
  }
  Sentry.captureException(error, additionalInfo);
};
